import { useParams } from 'react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MDEditor from '@uiw/react-md-editor';
import datenschutzContent from '../assets/datenschutzerklaerung.md?raw';

export function DataAgreementRoute() {
  const { i18n } = useTranslation('data_privacy');

  const { embedded, language } = useParams();

  // for embedded form
  const isEmbedded = embedded === 'embedded';

  useEffect(() => {
    if (isEmbedded) {
      document.querySelector('body')?.classList.add('bg-[#F8F9FA]');
      document.querySelector('#header')?.classList.add('hidden');
      document.querySelector('#footer')?.classList.add('hidden');
    }
  }, [isEmbedded]);

  useEffect(() => {
    const lang = language?.toLowerCase();
    if (lang === 'en' || lang === 'de') {
      i18n.changeLanguage(lang);
    }
  }, [language, i18n]);

  useEffect(() => {
    document.title = 'Termios - Datenschutzerklärung';
  }, []);

  if (isEmbedded) {
    return (
      <div className="bg-gray-50 rounded-xl p-6 text-[#454545] mb-16">
        <div>
          <h2 className="mb-4 font-semibold text-xl">Data Agreement</h2>
          <div data-color-mode="light" className="data-agreement-markdown">
            <MDEditor.Markdown source={datenschutzContent} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">Data Agreement</h1>
      <h2 className="font-bold text-4xl mb-16 whitespace-pre-line">Datenschutzerklärung</h2>

      <div className="bg-gray-50 rounded-xl shadow-lg border border-gray-200 p-6 text-[#454545] mb-16">
        <div data-color-mode="light" className="data-agreement-markdown">
          <MDEditor.Markdown source={datenschutzContent} />
        </div>
      </div>
    </div>
  );
}

export default DataAgreementRoute;